import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { WebShopService } from "../../services/webShop.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { RemoteGroupOrderServiceTimeExpiredComponent, SecureCheckDialogComponent } from "../../modalDialogs";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { RemoteOrderGroupOverviewService } from "./remoteOrderGroupOverview.service";
import { IRemoteGroupBasketItem, IRemoteGroupMember, IRemoteGroupMemberItems } from "./remoteOrderGroupOverview.facade";
import { MatCheckboxChange } from "@angular/material";
import { take } from "rxjs/operators";
import { GroupStateService } from "../../services/groupState.service";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { IGroupManageData, Status } from "../../services/IRemoteGroupOrderService";

@Component({
  selector: "remoteOrderGroupOverview",
  templateUrl: "./remoteOrderGroupOverview.component.html",
  styleUrls: ["./remoteOrderGroupOverview.component.scss"],
  providers: [RemoteOrderGroupOverviewService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class RemoteOrderGroupOverviewComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;

  public isSmallView: boolean = false;
  // Number of members to display initially
  public memberDisplayLimit: number = 6;
  public displayToggle: boolean = false;
  public show_more: boolean = false;
  public currentOpenCommentId: number | null = null;
  public userId: number;
  public groupManageData: IGroupManageData;
  public groupMembers$: Observable<IRemoteGroupMember[]>;
  public groupbasketItems$: Observable<IRemoteGroupMemberItems[]>;
  public open_price$: Observable<number>;
  public item_count$: Observable<number>;
  public allMembersAreReady$: Observable<boolean>;
  public paymentStatusFinishing$: Observable<boolean>;

  public get groupName(): string {
    return this._remoteOrderGroupOverviewService.groupName;
  }

  public get groupCreator(): string {
    return this._remoteOrderGroupOverviewService.groupCreator;
  }

  constructor(private _location: Location
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private internationalisationService: InternationalisationService
    , private _webShopService: WebShopService
    , private _remoteOrderGroupOverviewService: RemoteOrderGroupOverviewService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _groupStateService: GroupStateService
  ) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me.groupManageData = me._remoteGroupOrderService.groupManageData;
    me.groupMembers$ = me._remoteOrderGroupOverviewService.groupMembers$;
    me.groupbasketItems$ = me._remoteOrderGroupOverviewService.groupMemberItems$;
    me.open_price$ = me._remoteOrderGroupOverviewService.open_price$;
    me.item_count$ = me._remoteOrderGroupOverviewService.item_count$;
    me.allMembersAreReady$ = me._remoteOrderGroupOverviewService.allMembersAreReady$
    me.paymentStatusFinishing$ = me._remoteOrderGroupOverviewService.paymentStatusFinishing$;
    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteOrderGroupOverviewComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public trackMemberOverviewBy(member: IRemoteGroupMember) {
    return member.userId;
  }

  /**User list title */
  public get groupOverViewTitle(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_GroupOverview_Title")
      .replace("{groupName}", `<br><span class="emphasized">${me.groupName}</span><br>`)
      .replace("{groupCreatorName}", `<span class="emphasized">${me.groupCreator}</span>`);
  }

  /** Formated amount*/
  public setItemAmount(amount: number) {
    const me = this;
    return me._webShopService.formatCurrency(amount);
  }

  /** Ordering information of each group member*/
  public setItemsCount(count: number): string {
    return count.toString();
  }

  /** group basket items count*/
  public setIGroupOrderCount(count: number) {
    return count.toString();
  }

  public Displaytoggle(memberCount: number): boolean {
    const me = this;
    return memberCount > me.memberDisplayLimit ? me.displayToggle = true : me.displayToggle = false;
  }

  /** toggle show more/less */
  public toggleShowMore() {
    const me = this;
    me.show_more = !me.show_more;
  }

  /** change state "Ready" */
  public async changeStateReady(userId: number, event: MatCheckboxChange) {
    const me = this;
    await me._remoteOrderGroupOverviewService.changeStateReady(userId, event.checked);
    me.PushChanges();
  }

  /**
   * Checks if the current user is the owner
   * Determines if the user can edit the basket state and perform related actions */
  public currentlyUserIsOwner(userId: number): boolean {
    const me = this;
    return userId === me._remoteGroupOrderService.groupManageData.userId
  }

  public get userIsGroupCreator() {
    const me = this;
    return me._remoteGroupOrderService.userIsGroupCreator;
  }

  public navigateToPayment() {
    const me = this;
    let allMembersAreReady = false;
    me.allMembersAreReady$.pipe(take(1)).subscribe(value => allMembersAreReady = value).unsubscribe();
    const expired = me.ServiceTimeExpired();
    if (expired) {
      me.openServiceTimeExpiredDialog(allMembersAreReady);
    } else {
      me.confirmSendOrder(allMembersAreReady);
    }
  }

  /** Send Group Order */
  private navigateToPay() {
    const me = this;
    me._router.navigate(["/remoteOrderGroupPayment"]);
  }

  public handleIncrementItem(basekItm: IRemoteGroupBasketItem) {
    const me = this;
    let finishing = false;
    me._remoteGroupOrderService.groupStatusPaymentStarted$.pipe(take(1)).subscribe(value => finishing = value).unsubscribe();
    finishing ? me._remoteGroupOrderService.notifyPaymentStarted(false) : basekItm.increment();
  }

  public handleDecrementItem(basekItm: IRemoteGroupBasketItem) {
    const me = this;
    let finishing = false;
    me._remoteGroupOrderService.groupStatusPaymentStarted$.pipe(take(1)).subscribe(value => finishing = value).unsubscribe();
    finishing ? me._remoteGroupOrderService.notifyPaymentStarted(false) : basekItm.decrement();
  }

  private ServiceTimeExpired() {
    const me = this;
    const expired = me._remoteGroupOrderService.ServiceTimeExpired();
    return expired;
  }

  private openServiceTimeExpiredDialog(allMembersAreReady: boolean) {
    const me = this;
    const dialog = me._bottomSheetHelperService.open(RemoteGroupOrderServiceTimeExpiredComponent, {
      data: {
        leadTime: me._remoteGroupOrderService.leadTime,
        selectedServiceTime: me.groupManageData.selectedServiceTime,
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });

    dialog.afterDismissed().subscribe((dialogResult) => {
      if (dialogResult && dialogResult === "change") {
        me.confirmSendOrder(allMembersAreReady);
      }
      me.PushChanges();
    });
  }

  private confirmSendOrder(allMembersAreReady: boolean) {
    const me = this;
    const description = allMembersAreReady ? "phRemoteOrder_SendOrderDialog_Description" : "phRemoteOrder_SendOrderDialog_Description_StateReady";
    const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phRemoteOrder_SendOrderDialog_Title",
        description: description,
        buttonTextAccept: "phRemoteOrder_SendOrderDialog_AcceptBtn",
        buttonTextDeny: "phRemoteOrder_SendOrderDialog_DenyBtn",
        icon: "hypersoft-achtung.svg",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    dialog.afterDismissed().subscribe(async (result: any) => {
      if (result) {
        await me._remoteGroupOrderService.setGroupPaymentStatus(Status.Finishing);
        me.navigateToPay();
      } //else nothing
    });

  }

  /**
   * Navigates to the menu detail.
   * 
   * @param {number} basketItemid - The ID of the basket item to view details for.
   */
  public viewDetails(basketItemid: number) {
    const me = this;
    const currentLocation = me._webShopService.locationID;
    me._router.navigate(["menudetail", -1, basketItemid, currentLocation]);
  }

  public ViewGroupMemberOrder(userId: string) {
    const me = this;
    me._router.navigate(["/remoteOrderGroupMemberDetail", userId]);
  }

  /** Navigation to GroupOrderInvite view */
  public NavigateToShareLink() {
    const me = this;
    me._groupStateService.setshownavigatetomenu(false);
    me._router.navigate(['/remoteOrderGroupShare']);
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }
}
